module.exports = __webpack_public_path__ + "static/media/mobile-registration-2-icon.485aa6ec.png";